import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Project} from '../components/Proyect';
import {useState} from 'react';
import Slide from '@mui/material/Slide';
import Grow from '@mui/material/Grow';
import { useRef } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Link from '@mui/material/Link';


//Modal
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle color="primary" sx={{ m: 0, p: 2, 
        background: 'rgb(63, 63, 63)'}} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            color="primary"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
  };




export default function Projects(){

    //Tamaño de columnas dependiendo del size de pantalla
    const [tam, setTam] = useState(4)

    //animacion
    const [checked, setChecked] = useState(true)

    //aumento de 3 en 3
    const [triada, setTriada] = useState(1)

    //onClick
    const [abrirProyecto, setAbrirProyecto] = useState(false)

    //Id del proyecto
    const [proyectoId, setProyectoId] = useState(null);

    //Llena local storage
    const [localS, setLocalS] = useState(false);

    const handleClickOpen = (id) => {
        setAbrirProyecto(true);
        setLocalS(true);
        setProyectoId(id);
        localStorage.setItem("id", proyectoId);

      };
      const handleClose = () => {
        setAbrirProyecto(false);
      };


    const size = () => typeof window !== "undefined" && window.addEventListener("resize", function() {
    if (window.matchMedia("(min-width: 600px)").matches) {
        setTam(4);
      }
      else{
        setTam(12); 
      }
    })

    const aumentando = () => {
        setTriada(triada + 1)
    }

    //Animacion
    const nodeRef = useRef(null);


    size();



    return(
        <Box mt={8} mb={28} sx={{ width: '100%', 
        backgroundColor:'black' }} alignItems="center"
        justifyContent="center">
        <Box mb={10}>
        <Grow in={true} timeout={1000}>
            <Typography gutterBottom variant="h3"  sx={{color:'white',
            paddingTop: 8,
            fontFamily: 'Questrial', "&:hover":{color:'#4dd0e1'}}}>
                My projects</Typography>
            </Grow>
        </Box>

        <Grid container pl={3} pr={3} ref={nodeRef} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{alignItems:"center",
        justifyContent:"center"}}>

               {Project.map((project, index) => (

                <Slide direction="right" in={checked} timeout={10000*triada} mountOnEnter unmountOnExit>

                <Grid item key={index} xs={tam} alignItems="center"
                    justifyContent="center" pl={500}>
                    <Card in='true'
                    sx={{ maxWidth: 445,
                    background: 'rgb(43, 43, 43)',
                    "&:hover":{background:'rgb(56, 56, 56)'}}}>
                        <CardMedia
                            component="img"
                            height="280"
                            image={project.image}
                            alt= {project.title}
                        />
                            <CardContent>
                                <Typography gutterBottom color="primary"
                                variant="h5" 
                                component="div">
                                {project.title}
                                </Typography>
                                <Typography variant="body2" color="rgb(186, 186, 186)">
                                {project.description}
                                </Typography>
                                
                            </CardContent>
                        <CardActions>
                            <Button size="small" color="secondary"
                            sx={{fontFamily: 'Questrial'}}
                            onClick={() => handleClickOpen(project.id)}> 
                            Learn More</Button>
                        </CardActions>
                    </Card>            
                </Grid>
                </Slide>
                ))
                }
        </Grid>
        
        {Project.forEach(function(e){
                
                if(e.id === proyectoId){
                    console.log(e.id + '' + proyectoId + 'son iguales');
                    localStorage.setItem("nombre", e.title);
                    localStorage.setItem("description", e.description);
                    localStorage.setItem("image", e.image);
                    localStorage.setItem("tech", e.techs.name);
                    localStorage.setItem("tech1", e.techs.name1);
                    localStorage.setItem("adinfo", e.adinfo);
                    localStorage.setItem("link", e.link);
                }
                 })
        }


        {localS === true &&
         <BootstrapDialog
         onClose={handleClose}
         aria-labelledby="customized-dialog-title"
         open={abrirProyecto}
       >
         <BootstrapDialogTitle 
         id="customized-dialog-title" onClose={handleClose}>
         {localStorage.getItem("nombre")}
         </BootstrapDialogTitle>
         <DialogContent dividers
         sx={{background: 'rgb(63, 63, 63)',
         color:'rgb(186, 186, 186)'}}>

         <CardMedia
            component="img"
            height="380"
            image={localStorage.getItem("image")}
         />

           <Typography mt={2} variant="p" component="h3"
           gutterBottom>
           {localStorage.getItem("description")}
           </Typography>
           <Typography gutterBottom>
           <Typography sx={{fontWeight:'bold'}}>Techs:</Typography>
           {localStorage.getItem("tech")}, {localStorage.getItem("tech1")}
           </Typography>
           <Typography gutterBottom>
           <Link color="secondary" href={localStorage.getItem("adinfo")}>{localStorage.getItem("adinfo")}</Link>
           </Typography>
           <Typography sx={{fontWeight:'bold'}}> Link: </Typography>
           <Link color="secondary" href={localStorage.getItem("link")}>{localStorage.getItem("link")}</Link>
         </DialogContent>
       </BootstrapDialog>
       }


        </Box>
    )
};